/* istanbul ignore file */
import config from 'src/config'

import { io } from 'socket.io-client'

const socket = io(config.api_server, {
  reconnectionDelayMax: 1000,
})

export type tSocket = typeof socket

export interface ioFetchResponse {
  response: unknown
  error?: string
}

export interface fetchProps<request> {
  api?: string
  route: string
  action: string
  req?: request
}

export const fetch = async <request>({
  api = 'fetch',
  route, action, req,
}:fetchProps<request>) => {
  const response = await new Promise((resolve, reject) => {
    socket.emit(
      api, 
      {
        route,
        action,
        req,
      },
      (res:ioFetchResponse)=>{
        if (res.error) reject(res.error)
        else resolve(res.response)
      }
    ).on('error', (err:unknown)=>{
      reject(err)
    })
  })
  return response
}

export default socket